var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.roleperson.role == 1 && _vm.roleperson.refundState == 0)?_c('rebateapply',{attrs:{"details":_vm.details,"refundType":_vm.refundType},on:{"show1":_vm.showflow}}):_vm._e(),(
      (_vm.roleperson.role == 2 && _vm.roleperson.refundState == 1) ||
      (_vm.roleperson.role == 1 && _vm.roleperson.refundState == 1)
    )?_c('rebateappling',{attrs:{"afterSaleId":_vm.afterSaleId,"refundType":_vm.refundType},on:{"show2":_vm.showflow2,"show3":_vm.showflow3,"show4":_vm.showflow4}}):_vm._e(),(
      _vm.roleperson.refundState == 2 ||
      _vm.roleperson.refundState == 3 ||
      _vm.roleperson.refundState == 4
    )?_c('rebateed',{attrs:{"afterSaleId":_vm.afterSaleId,"refundType":_vm.refundType}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }